(function($) {
  $(function () {

    // Menu Toggle
    $('.js-menu-toggle').on('click', function(e) {
      $('.js-mobile-navigation').toggleClass('is-active');
    });

    // Mobile Menu Sub Menu Toggles
    var $mobileMenuParentLinks = $('#mobile-menu > .menu-item-has-children > a');
    $mobileMenuParentLinks.on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $mobileMenuParentLinks.not($(this)).removeClass('is-active');
    });

    // Side Menu Mobile Toggle
    $('.js-side-menu-toggle').on('click', function(e) {
      $(this).toggleClass('is-active');
      $('.side-menu ul').toggleClass('is-active');
    });
  });

  $('.js-fullwidth-slider').each(function() {
    $(this).slick({
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });
  });

})(jQuery);